module.exports = __webpack_public_path__ + "img/logoDA.5cb22f03.svg";